module.exports = __webpack_public_path__ + "img/partner_omron.68e12e14.jpg";